import { Token } from "inversify-token";
import { YinzCamSegmentationServiceComponent } from "./YinzCamSegmentationServiceComponent";

export const YinzCamSegmentationServiceToken = new Token<YinzCamSegmentationService>(Symbol.for("YinzCamSegmentationService"));

export interface YinzCamSegmentationService {
  getComponent(): YinzCamSegmentationServiceComponent;
}
